// utils/apiHelper.js
import axios from "axios";
import store from "../store";
import { handleUnauthorized } from "../features/auth/authSlice";
const DEFAULT_COMPANY_ID = 1;

// Create axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_HOST_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
    CompanyId: DEFAULT_COMPANY_ID, // Add here
  },
});

// Request interceptor to add authorization token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token_bearer");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers.CompanyId = DEFAULT_COMPANY_ID;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle unauthorized responses globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Dispatch unauthorized action to logout user
      store.dispatch(handleUnauthorized());
    }
    return Promise.reject(error);
  },
);

// GET request function
export const getRequest = (url, params = {}) => {
  return axiosInstance.get(url, { params });
};

// POST request function
export const postRequest = (url, data = {}) => {
  return axiosInstance.post(url, data);
};

// PUT request function
export const putRequest = (url, data = {}) => {
  return axiosInstance.put(url, data);
};

// DELETE request function
export const deleteRequest = (url) => {
  return axiosInstance.delete(url);
};

// PATCH request function
export const patchRequest = (url, data = {}) => {
  return axiosInstance.patch(url, data);
};

// Handle API response (legacy - keeping for compatibility)
export const handleApiResponse = (response) => {
  if (response.status === 401) {
    store.dispatch(handleUnauthorized());
  }
  return response;
};

// Handle API error (legacy - keeping for compatibility)
export const handleApiError = (error) => {
  if (error.response && error.response.status === 401) {
    store.dispatch(handleUnauthorized());
  }
  return Promise.reject(error);
};

// Export the axios instance as default
export default axiosInstance;
